<div id="suppliers" class="supplier-tab" *psUiHasRole="['buyer', 'operator']">
  <div class="tab-content table-responsive">
    <table class="table survey-detail-table">
      <thead class="text-center">
        <tr>
          <th
            class="supplier-th-name"
            [psUiSortTable]="suppliers"
            data-order=""
            data-name="name"
          >
            Name
          </th>
          <th
            class="min-wid-60"
            [psUiSortTable]="suppliers"
            data-name="intentIcon"
          >
            Intent
          </th>
          <th
            *ngIf="!survey.is_qbp_enable"
            class="min-wid-100"
            [psUiSortTable]="suppliers"
            data-order=""
            data-name="cpi"
          >
            Current CPI
          </th>
          <th
            class="text-center min-wid-100 average-cpi current-target-th"
            *ngIf="survey.is_qbp_enable"
          >
            <label class="mid-icon-position">
              Average CPI
              <div class="help-tip current-target average-cpi">
                <i class="fa fa-info-circle" aria-hidden="true"></i>
                <p class="not-capitalize">
                  <span
                    >This project has the ability to price each quota
                    differently. As a result, we can no longer report on
                    'Current CPI'; instead we report the 'Average CPI' for each
                    supplier.</span
                  >
                </p>
              </div>
            </label>
          </th>
          <th
            class="min-wid-90"
            [psUiSortTable]="suppliers"
            data-order=""
            data-name="remaining"
          >
            Remaining
          </th>
          <th
            *ngIf="survey.click_balancing"
            class="min-wid-119"
            [psUiSortTable]="suppliers"
            data-order=""
            data-name="valid_clicks"
          >
            Click Fielded<br />Vs<br />Click Goal
          </th>
          <th
            *ngIf="!survey.click_balancing"
            class="min-wid-119"
            [psUiSortTable]="suppliers"
            data-order=""
            data-name="fielded"
          >
            Fielded Vs Goal
          </th>
          <th
            class="min-wid-105"
            [psUiSortTable]="suppliers"
            data-order=""
            data-name="srv_start_count"
          >
            Survey Starts
          </th>
          <th
            class="min-wid-130"
            [psUiSortTable]="suppliers"
            data-order=""
            data-name="last_start_date"
          >
            Last Survey Start
          </th>
          <th
            class="min-wid-50"
            [psUiSortTable]="suppliers"
            data-order=""
            data-name="buyer_in_progress"
          >
            In Progress
          </th>
          <th
            class="min-wid-50"
            *ngIf="isAdvanceStatsEnable"
            [psUiSortTable]="suppliers"
            data-order=""
            data-name="ps_start_count_24"
          >
            Last 24 Hours
          </th>
          <th *ngIf="enableAccordianMenu"></th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td colspan="13">
            <ps-ui-accordion [closeOthers]="true" [arrowToggleOnly]="true">
              <ps-ui-accordion-section
                *ngFor="
                  let supplier of suppliers;
                  let index = index;
                  let last = last
                "
                [disabled]="!enableAccordianMenu"
                [class.last-child]="last"
              >
                <ng-template psUiAccordionTitle>
                  <table class="table supplier-inner-table">
                    <tr [class.supplier-summary]="index === 0">
                      <th class="text-left min-wid-222">
                        <span>{{
                          supplier.group_ref
                            ? supplier.group_name
                            : supplier.suppliers[0].name
                        }}</span>
                        <ps-ui-pds-label
                          *ngIf="supplier.is_pds_applied"
                          class="ps-0"
                          [companyId]="survey.companyId"
                          [supplierId]="supplier.suppliers[0].id"
                          [cpi]="supplier.cpi"
                          [fee]="supplier.fee"
                          [top]="last"
                        ></ps-ui-pds-label>
                      </th>
                      <th class="intent-icons min-wid-60">
                        <span
                          id="intent_xicon"
                          *ngIf="supplier.intentIcon[0] === 'RED_CROSS'"
                        >
                          <i class="fa fa-times" aria-hidden="true"></i>
                        </span>

                        <label
                          *ngIf="supplier.intentIcon[0] === 'YELLOW_CROSS'"
                        >
                          <span class="help-tip intent-icon margin-0">
                            <i class="fa fa-times" aria-hidden="true"></i>
                            <p>
                              <span>
                                {{ supplier.name }}
                                has zero intent for following survey(s)
                                {{ supplier.intentIcon[1].join(', ') }}
                              </span>
                            </p>
                          </span>
                        </label>

                        <span
                          id="intent_chkicon"
                          *ngIf="supplier.intentIcon[0] === 'GREEN_CHECK'"
                        >
                          <i class="fa fa-check" aria-hidden="true"></i>
                        </span>

                        <label
                          *ngIf="
                            supplier.intentIcon[0] === 'YELLOW_EXCLAMATION'
                          "
                        >
                          <span class="help-tip intent-icon margin-0">
                            <i class="fa fa-exclamation" aria-hidden="true"></i>
                            <p>
                              <span>
                                {{
                                  supplier.group_ref
                                    ? supplier.group_name
                                    : supplier.suppliers[0].name
                                }}
                                has no intent for following survey(s)
                                {{ supplier.intentIcon[1].join(', ') }}
                              </span>
                            </p>
                          </span>
                        </label>
                        <span
                          id="intent_quetnicon"
                          *ngIf="supplier.intentIcon[0] === 'BLACK_QUESTION'"
                        >
                          <i class="fa fa-question" aria-hidden="true"></i>
                        </span>
                      </th>
                      <th
                        class="text-center min-wid-100"
                        *ngIf="!survey.is_qbp_enable"
                      >
                        {{ supplier.currency_symbol }}{{ supplier.cpi }}
                      </th>
                      <th
                        class="text-center min-wid-100"
                        *ngIf="survey.is_qbp_enable"
                      >
                        {{
                          supplier.average_cpi
                            ? (supplier.average_cpi
                              | currency : survey.currencySymbol)
                            : '--'
                        }}
                      </th>
                      <th class="text-center min-wid-90">
                        {{ supplier.remaining | caping }}
                      </th>
                      <th class="text-center min-wid-119">
                        {{
                          supplier.click_balance
                            ? (supplier.valid_clicks | caping)
                            : (supplier.fielded | caping)
                        }}
                        &nbsp;|&nbsp;
                        {{ supplier.completes_goal | caping }}
                      </th>
                      <th class="text-center min-wid-105">
                        {{ supplier.srv_start_count }}
                      </th>
                      <th class="text-center min-wid-130">
                        {{
                          supplier.last_start_date
                            ? (supplier.last_start_date
                              | date : 'MM/dd/yyyy h:mma')
                            : '--'
                        }}
                      </th>
                      <th class="text-center min-wid-90">
                        {{ supplier.buyer_in_progress }}
                      </th>
                      <th
                        *ngIf="isAdvanceStatsEnable"
                        class="text-center min-wid-108"
                      >
                        {{ supplier.ps_start_count_24 | caping }}
                      </th>
                    </tr>
                  </table>
                </ng-template>
                <div
                  id="collps{{ index }}"
                  class="accordian-body supplier-accordion-body-table"
                >
                  <table *ngIf="isAdvanceStatsEnable && index !== 0">
                    <thead>
                      <tr class="text-center">
                        <th class="avg-col" colspan="2">
                          <span>Average</span>
                        </th>
                        <th class="width-23">Bid&nbsp; &nbsp;</th>
                        <th class="width-25">Max</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td class="left-60">CPI</td>
                        <td class="text-center">
                          {{
                            supplier.average_cpi
                              ? (supplier.average_cpi
                                | currency : survey.currencySymbol)
                              : '--'
                          }}
                        </td>

                        <td class="text-center">
                          {{
                            supplier.bid_cpi
                              ? (supplier.bid_cpi
                                | currency : survey.currencySymbol)
                              : '--'
                          }}
                        </td>
                        <td class="text-center">
                          {{
                            supplier.max_cpi
                              ? (supplier.max_cpi
                                | currency : survey.currencySymbol)
                              : '--'
                          }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <table class="supplier-second-accordion-tbl">
                    <thead>
                      <tr class="text-center">
                        <th
                          class="second-tbl-col"
                          *ngIf="supplier.performance"
                          colspan="2"
                        >
                          <span>Total</span>
                        </th>

                        <th *ngIf="supplier.performance" class="width-22">
                          % of Supplier Total&nbsp; &nbsp;
                        </th>

                        <th *ngIf="!supplier.performance" class="width-25">
                          Supplier's Share of Status
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        *ngFor="
                          let supplierPerformance of supplier.performance;
                          let index = index
                        "
                      >
                        <td class="left-60">{{ supplierPerformance?.name }}</td>
                        <td class="text-center">
                          {{ supplierPerformance?.count }}
                        </td>

                        <td class="text-center">
                          {{ supplierPerformance.percentage_of_supplier_total }}
                        </td>
                        <td class="text-center">
                          {{ supplierPerformance.supplier_share_status }}
                        </td>
                      </tr>
                      <tr *ngIf="supplier.perOfSupplrTotl">
                        <td class="left-60">% of Supplier Total</td>
                        <td class="text-center">
                          {{ supplier.perOfSupplrTotl }}
                        </td>
                      </tr>
                      <tr *ngIf="supplier.supplier_share_status">
                        <td class="left-60">Supplier's Share of Status</td>
                        <td class="text-center">
                          {{ supplier.supplier_share_status }}
                        </td>
                      </tr>
                      <tr *ngIf="supplier.valid_clicks">
                        <td class="left-60">Valid Clicks</td>
                        <td class="text-center">
                          {{ supplier.valid_clicks || (0 | caping) }}
                          ({{ supplier.valid_click_percentage || 0 }}%)
                        </td>

                        <td class="text-center" class="srv_start_count-td">
                          {{
                            supplier.valid_epc
                              ? (supplier.valid_epc
                                | currency : survey.currencySymbol)
                              : '--'
                          }}
                        </td>
                      </tr>
                      <tr *ngIf="supplier.srv_start_count">
                        <td class="left-60">Total Clicks</td>
                        <td class="text-center">
                          {{ supplier.srv_start_count | caping }}
                        </td>
                        <td class="text-center" class="srv_start_count-td">
                          {{
                            supplier.total_epc
                              ? (supplier.total_epc
                                | currency : survey.currencySymbol)
                              : '--'
                          }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </ps-ui-accordion-section>
            </ps-ui-accordion>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
